<template>
  <overlay class="booking"
           :is-active="getCurrentEvent !== null"
           @close="closeOverlayHandler"
           :wrapper-custom-style="customStyle">
    <template #content>
      <div class="booking__inner" v-if="getCurrentEvent && !isBooked">
        <!-- Show alert if not logged in -->
        <div class="alerting" v-if="!isLoggedIn">
          <img class="alerting__icon" src="~@/assets/images/alert.svg" alt="Bell">
          <div class="alerting__info">
            <p class="alerting__text">{{ $t('booking.isNotLogged') }}</p>
            <p class="alerting__text">{{ $t('booking.isNotAllowedToBook') }}</p>
          </div>
        </div>

        <!--  Call2action  -->
        <transition name="trs-fade-out" mode="out-in">
          <div key="1" class="booking__c2a" v-if="!isLoggedIn">
            <router-link :to="{name: 'Register'}" class="button button--outline">Registrieren</router-link>
            <router-link :to="{name: 'Login'}" class="button button--primary">Anmelden</router-link>
          </div>
        </transition>

        <div class="event-card" :class="{'event-card--color': event.color}" :style="customStyle">
          <div class="event-card__top">
            <div class="event-card__date">
              <span class="event-card__date-day">{{ event.day }}</span>
              <span class="event-card__date-month">{{ event.month }}</span>
            </div>

            <div class="event-card__price event-card__spacing">
              <div class="event-card__label">
                <icon class="icon--price" symbol="icon-price"/>
                <span class="event-card__label-text">Preis</span>
              </div>
              <p class="event-card__price-text">{{ event.price }}</p>
            </div>
          </div>
          <h3 class="event-card__title event-card__spacing">{{ event.title }}</h3>
          <div class="event-card__content" v-html="event.content"/>
          <div class="event-card__time event-card__spacing">
            <div class="event-card__label">
              <icon symbol="icon-clock"/>
              <span class="event-card__label-text">Wann?</span>
            </div>
            <p>{{ event.startDate }}</p>
            <p>von {{ event.startTime }} bis {{ event.endTime }}</p>
          </div>

          <div class="event-card__location event-card__spacing">
            <div class="event-card__label">
              <icon symbol="icon-location"/>
              <span class="event-card__label-text">Wo?</span>
            </div>
            <p>{{ event.address }}</p>
          </div>
          <div class="event-card__available-places event-card__spacing" v-if="isLoggedIn">
            <div class="event-card__label">
              <icon symbol="icon-person"/>
              <span class="event-card__label-text">Verfügbare Plätze: {{ availablePlacesForCategory }}</span>
            </div>

          </div>
        </div>
        <div class="event-card__price event-card__spacing">
          <br>
          <div class="event-card__available-places event-card__spacing" v-if="isLoggedIn">
            <div class="event-card__label">
              <span class="event-card__label-text">Platzgrösse auswählen</span>
            </div>

          </div>
          <div v-if="isLoggedIn">
            <div v-if="priceOptions.length" class="">
              <select v-model="event.price_type" @change="changePriceType($event)" class="custom-class"
                      :style="{'color':event.color}">
                <option v-for="item in priceOptions" :value="item.type" :key="item" :selected="item.type===event.price_type"
                        class="form__input">
                  <b>{{ item.text?item.text:'Standard' }}</b>
                </option>
              </select>
            </div>
            <div v-else>
              <select v-model="event.price_type" class="custom-class" :style="{'color':event.color}">
                <option disabled value="0" selected>
                  <b>Standard</b>
                </option>
              </select>
            </div>
          </div>

        </div>

        <!-- Logged in -->
        <div class="booking__isLogged" v-if="isLoggedIn">
          <template v-if="availablePlacesForCategory > 0">
            <h3>{{ $t('booking.totalNumberOfSeats') }}</h3>
            <div class="booking__quantity">
              <button class="booking__quantity-num" @click="minusEvent">-</button>
              <span class="booking__quantity-text">{{ counter }}</span>
              <button class="booking__quantity-num" @click="plusEvent">+</button>
              <div class="booking__select" v-if="requiresSeatSelection">
                <button @click="showPlansHandler" class="show__plan">Flohmarktplan zeigen</button>
                <p class="booking__select-label">Platznummer auswählen (mehrere Nummern können nach Anzahl Plätze
                  ausgewählt werden)</p>
                <app-multiselect
                    ref="seatsSelect"
                    class="booking__select-input"
                    v-model="value"
                    :options="options"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :hide-selected="true"
                    :max-height="150"
                    :max="counter"
                    :placeholder="'Platznummer auswählen'"
                    @open="onOpenSeats"
                    @close="onCloseSeats"
                    @select="onSeatSelect"
                    @remove="onSeatRemove"
                />
              </div>
            </div>
            <form @submit.prevent="submitEventHandler" class="form">
              <!--<div class="form__control">
                <label class="form__label" for="usercommemnt">Bemerkung/Wunsch (Optional)</label>
                <input class="form__input" type="text" name="usercommemnt" v-model="usercomment">
              </div>-->
              <div class="form__control form__control--checkbox"
                   :class="{ 'form__control--error': $v.book.checkboxOne.$error }">
                <input type="checkbox" id="checkbox1" class="form__checkbox" v-model="$v.book.checkboxOne.$model">
                <label for="checkbox1" class="form__label">
                  <span class="form__indicator" :class="{ 'event-card--color': event.color }" :style="customStyle"/>
                  <span class="form__text" v-html="$t('register.checkboxOne')"></span>
                </label>
              </div>
              <div class="booking__payment-section">
              <button class="button button--primary" :disabled="!isValidInput || $v.book.$invalid"
                      v-if="requiresSeatSelection">
                {{ $t('booking.bookNow', {price: event.updatedPrice || event.onlyPrice}) }}
              </button>
              <button class="button button--primary" :disabled="$v.book.$invalid" v-else>
                {{ $t('booking.bookNow', {price: event.updatedPrice || event.onlyPrice}) }}
              </button>
                <div class="payment-providers">
                  <img src="/card_twint.svg" alt="TWINT" class="payment-provider-icon" title="TWINT" />
                  <img src="/card_post-finance-pay.svg" alt="PF Pay" class="payment-provider-icon" title="PostFinance Pay" />
                  <img src="/card_visa.svg" alt="VISA" class="payment-provider-icon" title="VISA" />
                  <img src="/card_mastercard.svg" alt="Mastercard" class="payment-provider-icon" title="Mastercard" />
                </div>
              </div>
            </form>
          </template>
          <template v-else>
            <div class="event-card__c2a">
              <button class="button button--primary" disabled>{{ $t('booking.noBooking') }}</button>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template #status>
      <!-- Success Booking -->
      <transition name="trs-fade-out" mode="in-out">
        <app-success-message v-if="isBooked" @close="goToReservation" :message="successMessage"/>
      </transition>
    </template>
  </overlay>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import AppSuccessMessage from "@/components/AppSuccessMessage";
import AppMultiselect from 'vue-multiselect'
import {bookingPlansPhotoSwipe} from '@/vendors/photo-swipe'
import API from '@/services/endpoint'
import {sameAs} from 'vuelidate/lib/validators'

const MAX_NUMBERS = 5;

export default {
  name: "AppBooking",
  components: {
    AppSuccessMessage,
    AppMultiselect
  },
  validations: {
    book: {
      checkboxOne: {
        sameAs: sameAs(() => true)
      }
    }
  },
  watch: {
    '$route'() {
      this.setCurrentEvent(null)
    }
  },
  mounted(){},
  beforeDestroy(){},
  data() {
    return {
      isTouched: false,
      value: [],
      price: '',
      price_type: '',
      counter: 1,
      isBooked: false,
      usercomment: null,
      book: {
        checkboxOne: null,
      },
      plansList: [
        {src: require('@/assets/images/eg-floor.jpg'), w: 800, h: 600},
        {src: require('@/assets/images/1-floor.jpg'), w: 800, h: 600},
        {src: require('@/assets/images/2-floor.jpg'), w: 800, h: 600}
      ],
      paymentMethod: 'online',
      _isSeatsRefreshing: false,
      _seatsIntervalId: null,
      _isSeatsOpen: false
    }
  },
  computed: {
    ...mapGetters('bookEvents', ['getCurrentEvent']),
    ...mapGetters('auth', ['isLoggedIn', 'getCurrentUser']),
    event() {
      return {...this.getCurrentEvent}
    },
    successMessage(){
      return this.paymentMethod === 'online' ? 'Weiterleitung...' : null
    },
    priceOptions() {
      return this.getCurrentEvent.price_list;
    },
    priceType() {
      return this.getCurrentEvent.price_type
    },
    customStyle() {
      return {
        '--event-color': this.getCurrentEvent?.color,
      }
    },
    options() {
      const source = this.event && this.event.nums ? this.event.nums : []
      const nums = this.normalizeAvailableNums(source)
      return this.filterSeatsForPriceType(nums)
    },
    /** Show Platznummer picker only when this category actually has numbered seats. */
    requiresSeatSelection() {
      if (this.event.hasNums !== 1 && this.event.hasNums !== true) return false
      return this.currentCategoryHasSeatNumbers()
    },
    availablePlacesForCategory() {
      if (!this.event) return 0
      const priceType = this.event.price_type != null ? String(this.event.price_type) : ''
      if (this.requiresSeatSelection) {
        return Array.isArray(this.options) ? this.options.length : 0
      }
      const ranges = this.parseCategorySeatRanges(
        this.event.categorySeatRanges || this.event.category_seat_ranges
      )
      if (priceType && ranges && ranges[priceType] && ranges[priceType].places != null && ranges[priceType].places !== '') {
        const places = parseInt(ranges[priceType].places, 10)
        if (!isNaN(places) && places >= 0) return places
      }
      return typeof this.event.availablePlaces === 'number'
        ? this.event.availablePlaces
        : parseInt(this.event.availablePlaces, 10) || 0
    },
    pageId() {
      return this.$route.params.id
    },
    isValidInput() {
      if (!this.requiresSeatSelection) return true
      const opts = this.options
      const selectionValid = Array.isArray(this.value) && this.value.every(v => opts.includes(v))
      return selectionValid && this.counter === this.value.length
    }
  },
  methods: {
    ...mapActions('bookEvents', ['setCurrentEvent', 'postEventHandler']),
    ...mapActions('events', ['fetchEvents']),
    onOpenSeats(){
      this._isSeatsOpen = true
      this.refreshSeats()
    },
    onCloseSeats(){
      this._isSeatsOpen = false
    },
    async refreshSeats(){
      if (this._isSeatsRefreshing) return
      if (!this.event || !this.event.id) return
      this._isSeatsRefreshing = true
      try{
        const { data } = await API.get(`/v1/events/${this.event.id}/seats`)
        const payload = data && data.message ? data.message : null
        if (payload && Number(payload.id) === Number(this.event.id)){
          const mergedEvent = {
            ...this.event,
            availablePlaces: typeof payload.availableplaces !== 'undefined' ? payload.availableplaces : this.event.availablePlaces,
            nums: typeof payload.nums !== 'undefined' ? payload.nums : this.event.nums,
            categorySeatRanges: typeof payload.category_seat_ranges !== 'undefined'
              ? (() => {
                  const raw = payload.category_seat_ranges
                  if (!raw) return null
                  if (typeof raw === 'object') return raw
                  try { return JSON.parse(raw) } catch (e) { return this.event.categorySeatRanges }
                })()
              : this.event.categorySeatRanges,
            category_seat_ranges: typeof payload.category_seat_ranges !== 'undefined'
              ? payload.category_seat_ranges
              : this.event.category_seat_ranges
          }
          await this.setCurrentEvent(mergedEvent)
          await this.$nextTick()
          if (this._isSeatsOpen && this.$refs.seatsSelect && typeof this.$refs.seatsSelect.activate === 'function') {
            this.$refs.seatsSelect.activate()
          }
          const opts = this.options
          if (Array.isArray(this.value)) {
            const filtered = this.value.filter(v => opts.includes(v))
            if (filtered.length !== this.value.length) {
              this.value = filtered
            }
          }
        }
      }catch(e){
      } finally {
        this._isSeatsRefreshing = false
      }
    },
    parseCategorySeatRanges(raw) {
      if (!raw) return null
      if (typeof raw === 'object') return raw
      try {
        return JSON.parse(raw)
      } catch (e) {
        return null
      }
    },
    currentCategoryHasSeatNumbers() {
      const priceType = this.event.price_type != null ? String(this.event.price_type) : ''
      if (!priceType) return false
      const ranges = this.parseCategorySeatRanges(
        this.event.categorySeatRanges || this.event.category_seat_ranges
      )
      let slots = []
      try {
        const raw = this.event && this.event.nums
        const arr = Array.isArray(raw)
          ? raw
          : (typeof raw === 'string' ? JSON.parse(raw || '[]') : [])
        slots = Array.isArray(arr) ? arr : []
      } catch (e) {
        slots = []
      }
      const hasTyped = slots.some(
        (s) => s && typeof s === 'object' && s.type != null && s.type !== ''
      )
      if (hasTyped) {
        return slots.some(
          (s) => s && typeof s === 'object' && String(s.type) === priceType
        )
      }
      if (ranges && Object.keys(ranges).length) {
        const own = ranges[priceType]
        if (!own) return false
        const from = parseInt(own.from, 10)
        const to = parseInt(own.to, 10)
        return !isNaN(from) && !isNaN(to) && from > 0 && to > 0
      }
      // Innen/Aussen without Platznummern = quantity only (no seat list).
      const fromList = Array.isArray(this.event.price_list)
        ? this.event.price_list.find((p) => String(p.type) === priceType)
        : null
      const label = (fromList && fromList.text) || this.event.price_text || ''
      if (/^(Innenplatz|Aussenplatz)(\s|[–-]|$)/i.test(String(label).trim())) {
        return false
      }
      // Classic shared numbered event.
      return true
    },
    filterSeatsForPriceType(slots) {
      const priceType = this.event.price_type != null ? String(this.event.price_type) : ''
      const ranges = this.parseCategorySeatRanges(
        this.event.categorySeatRanges || this.event.category_seat_ranges
      )
      const hasTyped = slots.some(s => s && typeof s === 'object' && s.type != null && s.type !== '')
      if (hasTyped && priceType) {
        return slots
          .filter(s => s && typeof s === 'object' && String(s.type) === priceType)
          .map(s => parseInt(s.nr, 10))
          .filter(n => !isNaN(n))
          .sort((a, b) => a - b)
      }
      const nums = slots.map(s => (typeof s === 'number' ? s : parseInt(s && s.nr, 10))).filter(n => !isNaN(n))
      if (!ranges || !priceType) return [...new Set(nums)].sort((a, b) => a - b)
      const own = ranges[priceType]
      if (own) {
        const from = parseInt(own.from, 10)
        const to = parseInt(own.to, 10)
        if (!isNaN(from) && !isNaN(to)) {
          return [...new Set(nums.filter(n => n >= from && n <= to))].sort((a, b) => a - b)
        }
      }
      return [...new Set(nums)].sort((a, b) => a - b)
    },
    normalizeAvailableNums(raw){
      try{
        const arr = Array.isArray(raw)
          ? raw
          : (typeof raw === 'string' ? JSON.parse(raw || '[]') : [])
        if (!Array.isArray(arr)) return []
        return arr
          .filter(item => {
            if (typeof item === 'number') return true
            if (item && typeof item === 'object') {
              if (Object.prototype.hasOwnProperty.call(item, 'busy')) {
                return item.busy === 0 || item.busy === false
              }
              return Object.prototype.hasOwnProperty.call(item, 'nr')
            }
            return false
          })
          .map(item => {
            if (typeof item === 'number') return item
            const entry = { nr: item.nr }
            if (item.type != null && item.type !== '') entry.type = String(item.type)
            return entry
          })
      }catch(e){
        return []
      }
    },
    onSeatSelect(){
      const opts = this.options
      if (Array.isArray(this.value)) {
        this.value = this.value.filter(v => opts.includes(v))
      }
    },
    onSeatRemove(){
    },
    
    initPriceAndPriceList() {
      this.price = this.event.price;
      this.price_type = this.event.price_type;
      console.log("Initialized ", this.price, this.price_type)
    },
    minusEvent() {
      this.counter > 1 ? this.counter -= 1 : 1
      this.event['updatedPrice'] = (this.event['onlyPrice'] * this.counter)
    },
    plusEvent() {
      const max = this.availablePlacesForCategory
      if (this.counter >= max) return max
      this.counter <= max ? this.counter += 1 : max

      this.event['updatedPrice'] = (this.event['onlyPrice'] * this.counter)
    },
    closeOverlayHandler() {
      return new Promise((resolve, reject) => {
        this.setCurrentEvent(null)
        this.isBooked = false
        this.counter = 1;
        this.usercomment = null;
        resolve(true)
      })
    },
    submitEventHandler() {
      Swal.fire({
        title: 'Sind Sie sicher?',
        text: 'Sind Sie sicher, dass Sie die Buchung wollen?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, ich bin sicher!',
        cancelButtonText: 'Abbrechen'
      }).then((result) => {
        if (result.value) {
          let payload = {
            event: this.event.id,
            price_type: this.event.price_type,
            price_text: this.event.price_text?this.event.price_text:"Standard",
            price: this.event.onlyPrice,
            numplaces: this.counter,
            usercomment: this.usercomment,
            payment_method: this.paymentMethod
          }
          if (this.value.length > 0) {
            payload.nums = JSON.stringify(this.value)
          }
          this.postEventHandler(payload)
              .then((res) => {
                // If online payment selected, redirect to /pay
                const reservation = res && res.reservation ? res.reservation : null
                if (this.paymentMethod === 'online' && reservation && reservation.id) {
                  this.redirectToPayment(reservation.id)
                  return
                }
                if (res) this.isBooked = res;
                console.log("Response booking:", res)
                this.value = [];
                this.fetchEvents(this.pageId)
              })
              .catch(e => {
                if (e.success === false) {
                  if (e.message.includes("Die folgenden Nummern sind bereits reserviert")){
                    Swal.fire('Achtung', e.message, 'error')
                  }
                  else Swal.fire('Achtung', 'Etwas falsch passiert.', 'error')
                }
              })
        }
      })
    },
    async redirectToPayment(reservationId){
      try {
        Swal.fire({ title: 'Weiterleitung zur Zahlung...', allowOutsideClick: false, showConfirmButton: false, didOpen: () => { Swal.showLoading() } })

        const handlePageVisibility = () => {
          if (document.visibilityState === 'visible') {
            Swal.close()
            document.removeEventListener('visibilitychange', handlePageVisibility)
            window.removeEventListener('beforeunload', handleBeforeUnload)
          }
        }
        
        // Store current URL to detect if extension intercepts navigation
        let navigationDetected = false
        
        const handleBeforeUnload = () => {
          Swal.close()
          navigationDetected = true
          document.removeEventListener('visibilitychange', handlePageVisibility)
          window.removeEventListener('beforeunload', handleBeforeUnload)
        }
        
        document.addEventListener('visibilitychange', handlePageVisibility)
        window.addEventListener('beforeunload', handleBeforeUnload)
        
        const { data } = await API.post(`/v1/reservation/${reservationId}/pay`)
        const message = data && data.message ? data.message : data
        const url = message && message.payment_url ? message.payment_url : (data.payment_url || '')
        if (!url) throw new Error('no url')
        if (url === window.location.href) {
          throw new Error('Invalid payment URL')
        }
        try { sessionStorage.setItem('pf_payment_flow', '1') } catch(e) {}
        
        // Store current URL for extension detection
        const currentUrl = window.location.href
        
        // Try to open in new tab first
        const newWindow = window.open(url, '_blank')
        
        // Check if popup was blocked or failed to open
        if (!newWindow) {
          // Definitely blocked - redirect in same tab
          window.location.href = url
          return
        }
        
        // Check immediately if extension intercepted (current page URL changed)
        // Extensions like "No New Tabs" will navigate current page instead of opening new tab
        if (window.location.href !== currentUrl || navigationDetected) {
          // Extension intercepted - already navigating, don't do anything
          return
        }
        
        // Check multiple times with short intervals to catch async navigation
        const checkIntervals = [10, 50, 100, 200]
        checkIntervals.forEach(delay => {
          setTimeout(() => {
            if (window.location.href !== currentUrl || navigationDetected || document.visibilityState === 'hidden') {
              navigationDetected = true
            }
          }, delay)
        })
        
        // Check if window was actually opened (some browsers return object even if blocked)
        let popupOpened = false
        try {
          if (newWindow.closed) {
            throw new Error('Window immediately closed')
          }
          const test = newWindow.location
          popupOpened = true
        } catch (e) {
          // Popup was blocked - redirect in same tab
          window.location.href = url
          return
        }
        
        // Popup opened successfully - reload current page after short delay
        if (popupOpened) {
          setTimeout(() => {
            // Check if extension intercepted navigation
            if (navigationDetected || window.location.href !== currentUrl || document.visibilityState === 'hidden') {
              // Extension intercepted - already navigating, don't reload
              return
            }
            
            try {
              if (newWindow.closed) {
                // Popup was closed - redirect in same tab
                window.location.href = url
              } else {
                // Successfully opened in new tab - reload current page
                window.location.reload()
              }
            } catch (e) {
              // Cannot access window - redirect in same tab
              window.location.href = url
            }
          }, 300)
        }
      } catch(e) {
        Swal.close()
        Swal.fire('Achtung', 'Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.', 'error')
      }
    },
    goToReservation() {
      this.closeOverlayHandler()
          .then(_ => {
            this.$router.push({name: 'Profile.my-events'})
          })
    },
    showPlansHandler() {
      let options = {
        counterEl: true,
        showHideOpacity: true,
        arrowEl: true,
        arrowKeys: true,
      };
      bookingPlansPhotoSwipe(this.plansList);
    },
    changePriceType() {
      this.price_type = this.event.price_type;
      this.value = []

      let priceVal = (this.event.price_list.filter(el => el.type === this.event.price_type))[0].priceperplace;
      let priceText = (this.event.price_list.filter(el => el.type === this.event.price_type))[0].text;
      this.price = `${priceVal} CHF / Platz`;

      this.event.price = this.price;
      this.event.price_text = priceText? priceText: "Standard";
      this.event.onlyPrice = parseInt(priceVal);
      this.event.updatedPrice = this.counter * parseInt(priceVal);
      this.setCurrentEvent(this.event).then(() => {
        const max = this.availablePlacesForCategory
        if (this.counter > max && max > 0) {
          this.counter = max
          this.event.updatedPrice = this.counter * parseInt(priceVal)
          this.setCurrentEvent(this.event)
        }
      })
    }
  }

}
</script>
<style>
.custom-class {

  border: 1px solid rgba(128, 128, 128, 0.97);
  padding: 5px;
  border-radius: 3px;
  margin-top: 3px;
  width: 80%;
  background: white;
}

.booking__payment-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: flex-start;
}

.payment-providers {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 8px;
}

.payment-provider-icon {
  height: 24px;
  width: auto;
  max-width: 60px;
  object-fit: contain;
  opacity: 0.9;
  transition: all 0.2s ease;
}

.payment-provider-icon:hover {
  opacity: 1;
  transform: translateY(-1px);
}
</style>